import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-revision-notices-unordered-list-with-xml-section',
  templateUrl: './revision-notices-unordered-list-with-xml-section.component.html',
  styleUrls: ['./revision-notices-unordered-list-with-xml-section.component.scss']
})
export class RevisionNoticesUnorderedListWithXmlSectionComponent implements OnInit {
  @Input() sections: Section[] = [];
  constructor() {}

  ngOnInit(): void {}
}
